<script lang="ts">
    import { createEventDispatcher, onMount } from "svelte";

    const dispatch = createEventDispatcher();
    export let urls: { url: string; loadedEvent: boolean }[];
    let libScript: any;

    onMount(async () => {
        libScript.addEventListener("load", () => {
            dispatch("loaded");
        });
        libScript.addEventListener("error", (event: any) => {
            console.error("something went wrong", event);
            dispatch("error");
        });
    });
</script>

<svelte:head>
    {#each urls as url}
        {#if url.loadedEvent}
            <script bind:this={libScript} src={url.url}></script>
        {:else}
            <script src={url.url}></script>
        {/if}
    {/each}
</svelte:head>
